
import axios from 'axios';
import React from 'react'
import { error_handle } from '../../helpers/error';
class Captcha extends React.Component {

	constructor(props) {
	    super(props);
	    this.state={
			image: null,
			data: '',
		}
		this.hash = null
	    
	}

	getCaptcha() {
        return axios.request({
            url: '/authentication/authen/getCaptcha',
            method: 'get',
        })

            .then(response => {
                response = response['data']['data']
				this.setState({
					image: "data:image/png;base64," + response['image']
				})
				this.hash = response['hash']
            })

            .catch((error) => {
                error_handle(error)
                console.log(error);
                return false;
            })

    }


	componentDidMount(){
		this.getCaptcha()
		this.getCaptchaInterval = setInterval(()=>{
			this.getCaptcha()
		}, 120000)
	}

	componentWillUnmount(){
		if(this.getCaptchaInterval){
			clearInterval(this.getCaptchaInterval)
		}
	}

	getData = ()=>{
		return {
			captcha: this.state.data,
			hash: this.hash
		}
	}
	render(){
		return (
			<div className='d-flex' style={{height:'100%', width:'100%', borderRadius:5, overflow:'hidden'}}>
				<img style={{cursor:'pointer', width:100, height:40}} src={this.state.image} onClick={()=>{this.getCaptcha()}}></img>
				<input tabIndex = {this.props.tabIndex} style={{flexGrow:1, width:100}} type='text' value={this.state.data} onChange={(e)=>this.setState({data:e.target.value})}></input>
			</div>
	)
	}
	
}

export default Captcha